import script from "./MoveDevices.vue?vue&type=script&setup=true&lang=js"
export * from "./MoveDevices.vue?vue&type=script&setup=true&lang=js"

import "./MoveDevices.vue?vue&type=style&index=0&id=4d2035cb&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d2035cb"]])

export default __exports__